import * as Event from '../tools/Event';
import { addClass, removeClass, hasClass } from '../tools/DOM';


export const init = () => {
	const SELECTOR_TRIGGER = '[data-tooltip]';
	const SELECTOR = '.tooltip';
	const OPENED_CLASS = 'is-opened';

	const isOpened = (target) => hasClass(target, OPENED_CLASS);

	const getOpened = () => [...document.querySelectorAll(SELECTOR)].filter(isOpened);

	const getLinks = (target) => [...document.querySelectorAll(`[data-tooltip="#${target.getAttribute('id')}"]`)];

	const open = (target) => {
		const links = getLinks(target);
		addClass(target, OPENED_CLASS);

		links.forEach((link) => addClass(link, OPENED_CLASS));

	};

	const close = (target) => {
		const links = getLinks(target);
		removeClass(target, OPENED_CLASS);

		links.forEach((link) => removeClass(link, OPENED_CLASS));
	};

	const onClick = (event) => {
		const element = event.target.closest(SELECTOR_TRIGGER);

		if (!element) {
			return;
		}

		event.preventDefault();

		const target = document.querySelector(element.getAttribute('data-tooltip'));

		if (isOpened(target)) {
			close(target);
		} else {
			open(target);
		}

		const openedTooltips = getOpened().filter((element) => element !== target);

		openedTooltips.forEach(close);
	};

	const onAwayClick = (event) => {
		const element = event.target.closest(SELECTOR_TRIGGER) || event.target.closest(SELECTOR);

		if (element) {
			return;
		}

		const openedTooltips = getOpened();

		openedTooltips.forEach(close);
	};

	Event.on(document, 'click', onClick, SELECTOR_TRIGGER);
	Event.on(document, 'click', onAwayClick);
};



// WEBPACK FOOTER //
// ./src/js/components/tooltip.js